import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import taxiFleetPartnerListingUserPermissionDefinition from "./taxi-fleet-partner-listing-user-permission";

const useTaxiFleetPartnerListingUserPermissions = () => {
  return useUserPermissions(taxiFleetPartnerListingUserPermissionDefinition);
};

export default useTaxiFleetPartnerListingUserPermissions;
